import { canActAsComisionesAdmin, canActAsDirectivaGestion, canActAsMiembroDirectiva, canActAsTreasurer, } from "@/utils/courseRoles";
import { canManageWithdrawalBoard, canValidateWithdrawalArrival, canViewWithdrawalDayList, canManageElectivos, isDriverCourse, isGateGuardCourse, isInspectorCourse, } from "@/utils/funcionarios";
import { canAccessGuardianWithdrawals, canAccessKioskModule, isAlumnosCourse, isCpaCourse, isCpaDirectiva, isFuncionariosCourse, isKioskCourse, } from "@/utils/parseCourseCode";
const isNormalCourse = (curso) => {
    if (!curso)
        return false;
    return (!isCpaCourse(curso) &&
        !isFuncionariosCourse(curso) &&
        !isKioskCourse(curso) &&
        !isAlumnosCourse(curso));
};
const isCpaBoard = (ctx) => isCpaDirectiva(ctx.curso);
/** Registro de actividades — curso regular y CPA. */
export const ACTIVITY_FEATURES = [
    // —— Organización ——
    {
        id: "courses-boards",
        labelKey: "activities.features.coursesBoards.label",
        descriptionKey: "activities.features.coursesBoards.description",
        icon: "bi bi-journal-bookmark",
        routeName: "cpa-gestionar-cursos",
        section: "organization",
        canAccess: (ctx) => isCpaBoard(ctx),
    },
    {
        id: "surveys",
        labelKey: "activities.features.surveys.label",
        descriptionKey: "activities.features.surveys.description",
        icon: "bi bi-clipboard2-check",
        routeName: "encuestas-list",
        section: "organization",
        canAccess: (ctx) => (isNormalCourse(ctx.curso) &&
            canActAsDirectivaGestion(ctx.curso, ctx.userEmail)) ||
            isCpaBoard(ctx),
    },
    {
        id: "asignaciones",
        labelKey: "activities.features.asignaciones.label",
        descriptionKey: "activities.features.asignaciones.description",
        icon: "bi bi-diagram-3",
        routeName: "asignaciones-home",
        section: "organization",
        canAccess: (ctx) => {
            if (!ctx.curso)
                return false;
            if (isFuncionariosCourse(ctx.curso))
                return canManageElectivos(ctx.curso);
            return true;
        },
    },
    {
        id: "cpa-tasks",
        labelKey: "activities.features.tasks.label",
        descriptionKey: "activities.features.tasks.description",
        icon: "bi bi-check2-square",
        routeName: "tareas-mis",
        section: "organization",
        canAccess: (ctx) => isCpaBoard(ctx),
    },
    {
        id: "staff",
        labelKey: "activities.features.staff.label",
        descriptionKey: "activities.features.staff.description",
        icon: "bi bi-person-badge",
        routeName: "cpa-funcionarios",
        section: "organization",
        canAccess: (ctx) => isCpaBoard(ctx),
    },
    {
        id: "cpa-socios",
        labelKey: "activities.features.cpaSocios.label",
        descriptionKey: "activities.features.cpaSocios.description",
        icon: "bi bi-people",
        routeName: "cpa-socios",
        section: "organization",
        canAccess: (ctx) => isCpaBoard(ctx),
    },
    {
        id: "kiosk-admins",
        labelKey: "activities.features.kioskAdmins.label",
        descriptionKey: "activities.features.kioskAdmins.description",
        icon: "bi bi-person-gear",
        routeName: "cpa-kiosk-users",
        section: "organization",
        canAccess: (ctx) => isCpaBoard(ctx),
    },
    {
        id: "entry-validation",
        labelKey: "activities.features.entryValidation.label",
        descriptionKey: "activities.features.entryValidation.description",
        icon: "bi bi-qr-code-scan",
        routeName: "cpa-validacion-ingreso",
        section: "organization",
        canAccess: (ctx) => isCpaBoard(ctx),
    },
    // —— Comunidad ——
    {
        id: "commissions",
        labelKey: "activities.features.commissions.label",
        descriptionKey: "activities.features.commissions.description",
        icon: "bi bi-people",
        routeName: "comisiones-list",
        section: "community",
        canAccess: (ctx) => (isNormalCourse(ctx.curso) &&
            canActAsComisionesAdmin(ctx.curso, ctx.userEmail)) ||
            isCpaBoard(ctx),
    },
    {
        id: "school-life",
        labelKey: "activities.features.schoolLife.label",
        descriptionKey: "activities.features.schoolLife.description",
        icon: "bi bi-heart-pulse",
        routeName: "convivencia-resumen",
        section: "community",
        canAccess: (ctx) => isCpaBoard(ctx),
    },
    {
        id: "sports-delegates",
        labelKey: "activities.features.sportsDelegates.label",
        descriptionKey: "activities.features.sportsDelegates.description",
        icon: "bi bi-trophy",
        routeName: "deportes-delegados",
        section: "community",
        canAccess: (ctx) => isCpaBoard(ctx),
    },
    {
        id: "brotherhood-bank",
        labelKey: "activities.features.brotherhoodBank.label",
        descriptionKey: "activities.features.brotherhoodBank.description",
        icon: "bi bi-bank2",
        routeName: "banco-fraterno-dashboard",
        section: "community",
        canAccess: (ctx) => isCpaBoard(ctx),
    },
    {
        id: "calendar",
        labelKey: "activities.features.calendar.label",
        descriptionKey: "activities.features.calendar.description",
        icon: "bi bi-calendar2-event",
        routeName: "calendario-dashboard",
        section: "community",
        canAccess: (ctx) => isCpaBoard(ctx),
    },
    {
        id: "classifieds",
        labelKey: "activities.features.classifieds.label",
        descriptionKey: "activities.features.classifieds.description",
        icon: "bi bi-tags",
        routeName: "clasificados-home",
        section: "community",
        canAccess: ({ curso }) => isNormalCourse(curso),
    },
    {
        id: "transport",
        labelKey: "activities.features.transport.label",
        descriptionKey: "activities.features.transport.description",
        icon: "bi bi-bus-front",
        routeName: "transporte-mis",
        section: "community",
        canAccess: ({ curso }) => isNormalCourse(curso),
    },
    {
        id: "cpa-classifieds",
        labelKey: "activities.features.classifieds.label",
        descriptionKey: "activities.features.cpaClassifieds.description",
        icon: "bi bi-tags",
        routeName: "clasificados-moderacion",
        section: "community",
        canAccess: (ctx) => isCpaBoard(ctx),
    },
    {
        id: "suppliers",
        labelKey: "activities.features.suppliers.label",
        descriptionKey: "activities.features.suppliers.description",
        icon: "bi bi-building",
        routeName: "proveedores-dashboard",
        section: "community",
        canAccess: (ctx) => isCpaBoard(ctx),
    },
    {
        id: "kiosk",
        labelKey: "activities.features.kiosk.label",
        descriptionKey: "activities.features.kiosk.description",
        icon: "bi bi-shop-window",
        routeName: "kioscos-list",
        section: "community",
        canAccess: ({ curso }) => canAccessKioskModule(curso),
    },
    // —— Actividades ——
    {
        id: "manage-sales",
        labelKey: "activities.features.manageSales.label",
        descriptionKey: "activities.features.manageSales.description",
        icon: "bi bi-cart-check",
        routeName: "gestion-ventas",
        section: "activities",
        canAccess: (ctx) => canActAsTreasurer(ctx.curso, ctx.userEmail) &&
            (isNormalCourse(ctx.curso) || isCpaBoard(ctx)),
    },
    {
        id: "manage-donations",
        labelKey: "activities.features.manageDonations.label",
        descriptionKey: "activities.features.manageDonations.description",
        icon: "bi bi-gift-fill",
        routeName: "gestion-donaciones",
        section: "activities",
        canAccess: (ctx) => canActAsTreasurer(ctx.curso, ctx.userEmail) &&
            (isNormalCourse(ctx.curso) || isCpaBoard(ctx)),
    },
    {
        id: "fairs",
        labelKey: "activities.features.fairs.label",
        descriptionKey: "activities.features.fairs.description",
        icon: "bi bi-shop",
        routeName: "ferias-dashboard",
        section: "activities",
        canAccess: (ctx) => isCpaBoard(ctx),
    },
    {
        id: "kermesses",
        labelKey: "activities.features.kermesses.label",
        descriptionKey: "activities.features.kermesses.description",
        icon: "bi bi-balloon",
        routeName: "kermeses-dashboard",
        section: "activities",
        canAccess: (ctx) => isCpaBoard(ctx),
    },
    {
        id: "raffles",
        labelKey: "activities.features.raffles.label",
        descriptionKey: "activities.features.raffles.description",
        icon: "bi bi-ticket-perforated",
        routeName: "rifas-dashboard",
        section: "activities",
        canAccess: (ctx) => isCpaBoard(ctx),
    },
    {
        id: "tournaments",
        labelKey: "activities.features.tournaments.label",
        descriptionKey: "activities.features.tournaments.description",
        icon: "bi bi-trophy",
        routeName: "torneos-dashboard",
        section: "activities",
        canAccess: (ctx) => isCpaBoard(ctx),
    },
    {
        id: "ticket-events-admin",
        labelKey: "activities.features.ticketEventsAdmin.label",
        descriptionKey: "activities.features.ticketEventsAdmin.description",
        icon: "bi bi-ticket-perforated-fill",
        routeName: "eventos-dashboard",
        section: "activities",
        canAccess: (ctx) => isCpaBoard(ctx),
    },
    {
        id: "ticket-events",
        labelKey: "activities.features.ticketEvents.label",
        descriptionKey: "activities.features.ticketEvents.description",
        icon: "bi bi-ticket-perforated",
        routeName: "eventos-list",
        section: "activities",
        canAccess: () => true,
    },
    {
        id: "ticket-passes",
        labelKey: "activities.features.ticketPasses.label",
        descriptionKey: "activities.features.ticketPasses.description",
        icon: "bi bi-qr-code",
        routeName: "eventos-mis-entradas",
        section: "activities",
        canAccess: () => true,
    },
    {
        id: "ticket-events-staff",
        labelKey: "activities.features.ticketEventsStaff.label",
        descriptionKey: "activities.features.ticketEventsStaff.description",
        icon: "bi bi-shield-check",
        routeName: "eventos-staff-list",
        section: "activities",
        canAccess: () => true,
    },
    {
        id: "sales",
        labelKey: "activities.features.sales.label",
        descriptionKey: "activities.features.sales.description",
        icon: "bi bi-cart3",
        routeName: "ventas-list",
        section: "activities",
        canAccess: ({ curso }) => isNormalCourse(curso),
    },
    {
        id: "donations",
        labelKey: "activities.features.donations.label",
        descriptionKey: "activities.features.donations.description",
        icon: "bi bi-gift",
        routeName: "donaciones-list",
        section: "activities",
        canAccess: ({ curso }) => isNormalCourse(curso),
    },
    {
        id: "tasks",
        labelKey: "activities.features.tasks.label",
        descriptionKey: "activities.features.tasks.description",
        icon: "bi bi-check2-square",
        routeName: "tareas-mis",
        section: "activities",
        canAccess: ({ curso }) => isNormalCourse(curso),
    },
    // —— Comunicaciones ——
    {
        id: "mass-email",
        labelKey: "activities.features.massEmail.label",
        descriptionKey: "activities.features.massEmail.description",
        icon: "bi bi-envelope-paper",
        routeName: "email-masivo",
        section: "communications",
        canAccess: (ctx) => isNormalCourse(ctx.curso) &&
            canActAsDirectivaGestion(ctx.curso, ctx.userEmail),
    },
    {
        id: "cpa-mass-email",
        labelKey: "activities.features.cpaMassEmail.label",
        descriptionKey: "activities.features.cpaMassEmail.description",
        icon: "bi bi-envelope-paper",
        routeName: "email-masivo-cpa",
        section: "communications",
        canAccess: (ctx) => isCpaBoard(ctx),
    },
    {
        id: "sent-notifications",
        labelKey: "activities.features.sentNotifications.label",
        descriptionKey: "activities.features.sentNotifications.description",
        icon: "bi bi-mailbox",
        routeName: "notificaciones-email-list",
        section: "communications",
        canAccess: (ctx) => (isNormalCourse(ctx.curso) &&
            canActAsDirectivaGestion(ctx.curso, ctx.userEmail)) ||
            isCpaBoard(ctx),
    },
    {
        id: "website",
        labelKey: "activities.features.website.label",
        descriptionKey: "activities.features.website.description",
        icon: "bi bi-globe2",
        routeName: "sitio-web-dashboard",
        section: "communications",
        canAccess: (ctx) => isCpaBoard(ctx),
    },
    {
        id: "graphic-material",
        labelKey: "activities.features.graphicMaterial.label",
        descriptionKey: "activities.features.graphicMaterial.description",
        icon: "bi bi-palette",
        routeName: "material-grafico-credenciales",
        section: "communications",
        canAccess: (ctx) => isCpaBoard(ctx),
    },
    {
        id: "galleries",
        labelKey: "activities.features.galleries.label",
        descriptionKey: "activities.features.galleries.description",
        icon: "bi bi-images",
        routeName: "galerias-admin",
        section: "communications",
        canAccess: (ctx) => isCpaBoard(ctx),
    },
    {
        id: "association-link",
        labelKey: "activities.features.associationLink.label",
        descriptionKey: "activities.features.associationLink.description",
        icon: "bi bi-link-45deg",
        routeName: "crear-link-asociacion-curso",
        section: "communications",
        canAccess: (ctx) => isNormalCourse(ctx.curso) &&
            canActAsDirectivaGestion(ctx.curso, ctx.userEmail),
    },
    // —— Directiva ——
    {
        id: "edit-board",
        labelKey: "activities.features.editBoard.label",
        descriptionKey: "activities.features.editBoard.description",
        icon: "bi bi-person-gear",
        routeName: "modificar-directiva",
        section: "board",
        canAccess: (ctx) => isNormalCourse(ctx.curso) &&
            canActAsMiembroDirectiva(ctx.curso, ctx.userEmail),
    },
    {
        id: "cpa-board",
        labelKey: "activities.features.cpaBoard.label",
        descriptionKey: "activities.features.cpaBoard.description",
        icon: "bi bi-diagram-3",
        routeName: "modificar-directiva",
        section: "board",
        canAccess: (ctx) => isCpaBoard(ctx),
    },
];
export const ACTIVITY_SECTION_LABELS = {
    organization: "activities.sections.organization",
    community: "activities.sections.community",
    activities: "activities.sections.activities",
    communications: "activities.sections.communications",
    board: "activities.sections.board",
    treasury: "activities.sections.treasury",
    staff: "activities.sections.staff",
    account: "activities.sections.account",
};
/** Secciones del hub Grupo/CPA. Tesorería y staff no se pintan aquí. */
export const ACTIVITY_SECTION_ORDER = [
    "organization",
    "community",
    "activities",
    "communications",
    "board",
];
const DEFAULT_MODULE_FLAGS = {
    configurableByGroup: true,
    groupDefaultEnabled: true,
    userCanPin: true,
    supportsHomeWidget: false,
    surfaces: ["hub", "drawer"],
};
const MODULE_META = {
    "courses-boards": {
        availableFor: ["cpa"],
        drawerLabel: "Cursos y directivas",
        routeNames: [
            "cpa-gestionar-cursos",
            "cpa-crear-cursos",
            "ver-directivas",
            "crear-curso",
            "crear-curso-institucion",
            "crear-link-asociacion-directivas",
        ],
    },
    asignaciones: {
        availableFor: ["course", "cpa", "funcionarios"],
        drawerLabel: "Asignaciones",
        routeNames: [
            "asignaciones-home",
            "asignaciones-proceso",
            "asignaciones-preferencias",
            "asignaciones-participantes",
            "asignaciones-restricciones",
            "asignaciones-recursos",
            "asignaciones-cupos",
            "asignaciones-vocacional",
        ],
        routePrefixes: ["/user/asignaciones"],
    },
    surveys: {
        availableFor: ["course", "cpa"],
        drawerLabel: "Encuestas",
        routeNames: [
            "encuestas-list",
            "encuestas-nueva",
            "encuestas-editar",
            "encuestas-preview",
        ],
        routePrefixes: ["/user/encuestas"],
        routeNamePrefixes: ["encuestas-"],
    },
    "cpa-tasks": {
        availableFor: ["cpa"],
        drawerLabel: "Tareas",
        routeNames: ["tareas-mis", "tareas-grupo", "tareas-nueva", "tareas-detalle"],
        routePrefixes: ["/user/tareas"],
    },
    staff: {
        availableFor: ["cpa"],
        drawerLabel: "Funcionarios",
        routeNames: ["cpa-funcionarios"],
    },
    "cpa-socios": {
        availableFor: ["cpa"],
        drawerLabel: "Socios",
        routeNames: ["cpa-socios"],
    },
    "kiosk-admins": {
        availableFor: ["cpa"],
        drawerLabel: "Administradores de kiosco",
        routeNames: ["cpa-kiosk-users"],
    },
    "entry-validation": {
        availableFor: ["cpa"],
        drawerLabel: "Validación de ingresos",
        routeNames: ["cpa-validacion-ingreso"],
    },
    commissions: {
        availableFor: ["course", "cpa"],
        drawerLabel: "Comisiones",
        routeNames: ["comisiones-list", "comisiones-nueva", "comisiones-detalle"],
        routePrefixes: ["/user/comisiones"],
        routeNamePrefixes: ["comisiones-"],
    },
    "school-life": {
        availableFor: ["cpa"],
        drawerLabel: "Convivencia escolar",
        routeNames: [
            "convivencia-resumen",
            "convivencia-encargados",
            "convivencia-postulaciones",
            "convivencia-reuniones",
            "convivencia-evento-nuevo",
            "convivencia-evento-detalle",
            "convivencia-comunicaciones",
            "convivencia-configuracion",
        ],
        routePrefixes: ["/user/cpa/convivencia"],
        routeNamePrefixes: ["convivencia-"],
    },
    "sports-delegates": {
        availableFor: ["cpa"],
        drawerLabel: "Delegados deportivos",
        routeNames: ["deportes-delegados", "deportes-postulaciones"],
        routePrefixes: ["/user/cpa/deportes"],
        routeNamePrefixes: ["deportes-"],
    },
    "brotherhood-bank": {
        availableFor: ["cpa"],
        drawerLabel: "Banco Fraterno",
        routeNames: [
            "banco-fraterno-dashboard",
            "banco-fraterno-voluntarios",
            "banco-fraterno-voluntario",
            "banco-fraterno-oportunidades",
            "banco-fraterno-oportunidad-nueva",
            "banco-fraterno-oportunidad",
            "banco-fraterno-config",
        ],
        routePrefixes: ["/user/cpa/banco-fraterno"],
    },
    calendar: {
        availableFor: ["cpa"],
        drawerLabel: "Calendario institucional",
        routeNames: ["calendario-dashboard", "calendario-nuevo"],
        routePrefixes: ["/user/cpa/calendario"],
        routeNamePrefixes: ["calendario-"],
    },
    classifieds: {
        availableFor: ["course"],
        drawerLabel: "Clasificados",
        routeNames: ["clasificados-home"],
        routePrefixes: ["/user/clasificados"],
    },
    transport: {
        availableFor: ["course"],
        drawerLabel: "Transporte",
        routeNames: ["transporte-mis"],
        routePrefixes: ["/user/transporte"],
    },
    "cpa-classifieds": {
        availableFor: ["cpa"],
        drawerLabel: "Clasificados",
        routeNames: ["clasificados-moderacion"],
        routePrefixes: ["/user/cpa/clasificados"],
    },
    suppliers: {
        availableFor: ["cpa"],
        drawerLabel: "Proveedores",
        routeNames: ["proveedores-dashboard", "proveedores-detalle"],
        routePrefixes: ["/user/cpa/proveedores"],
    },
    kiosk: {
        availableFor: ["course", "cpa", "kiosk"],
        drawerLabel: "Kioscos",
        routeNames: [
            "kioscos-list",
            "kiosk-home",
            "kiosk-admin",
            "kiosk-pedidos",
            "kiosk-entregas",
            "kiosk-reservar",
            "kiosk-mis-pedidos",
        ],
        routePrefixes: ["/user/kioscos", "/user/kiosk"],
        routeNamePrefixes: ["kiosk-"],
    },
    "manage-sales": {
        availableFor: ["course", "cpa"],
        drawerLabel: "Gestionar ventas",
        drawerIcon: "bi bi-currency-dollar",
        routeNames: ["gestion-ventas"],
        requiresRoles: ["treasurer"],
    },
    "manage-donations": {
        availableFor: ["course", "cpa"],
        drawerLabel: "Gestionar donaciones",
        drawerIcon: "bi bi-box-seam",
        routeNames: ["gestion-donaciones"],
        requiresRoles: ["treasurer"],
    },
    fairs: {
        availableFor: ["cpa"],
        drawerLabel: "Ferias",
        routeNames: [
            "ferias-dashboard",
            "ferias-nueva",
            "ferias-editar",
            "ferias-postulaciones",
            "ferias-stands",
            "ferias-emprendedores",
        ],
        routePrefixes: ["/user/cpa/ferias"],
        routeNamePrefixes: ["ferias-"],
    },
    kermesses: {
        availableFor: ["cpa"],
        drawerLabel: "Kermeses",
        routeNames: [
            "kermeses-dashboard",
            "kermeses-config",
            "kermeses-nueva",
            "kermeses-detalle",
            "kermeses-cursos",
            "kermeses-productos",
            "kermeses-comprobantes",
        ],
        routePrefixes: ["/user/cpa/kermeses"],
    },
    raffles: {
        availableFor: ["cpa"],
        drawerLabel: "Rifas",
        routeNames: ["rifas-dashboard", "rifas-nueva", "rifas-detalle"],
        routePrefixes: ["/user/cpa/rifas"],
    },
    tournaments: {
        availableFor: ["cpa"],
        drawerLabel: "Torneos",
        routeNames: ["torneos-dashboard", "torneos-nuevo"],
        routePrefixes: ["/user/cpa/torneos"],
        routeNamePrefixes: ["torneos-", "torneos-chess-"],
    },
    "ticket-events-admin": {
        availableFor: ["cpa"],
        drawerLabel: "Eventos y entradas",
        routeNames: [
            "eventos-dashboard",
            "eventos-nuevo",
            "eventos-editar",
            "eventos-pagos",
            "eventos-metricas",
            "eventos-staff",
            "eventos-validar",
        ],
        routePrefixes: ["/user/cpa/eventos"],
    },
    "ticket-events": {
        availableFor: ["course", "cpa"],
        drawerLabel: "Eventos",
        routeNames: ["eventos-list"],
    },
    "ticket-passes": {
        availableFor: ["course", "cpa"],
        drawerLabel: "Mis entradas",
        routeNames: ["eventos-mis-entradas"],
    },
    "ticket-events-staff": {
        availableFor: ["course", "cpa"],
        drawerLabel: "Control de acceso",
        routeNames: ["eventos-staff-list"],
    },
    sales: {
        availableFor: ["course"],
        drawerLabel: "Ventas",
        routeNames: ["ventas-list"],
    },
    donations: {
        availableFor: ["course"],
        drawerLabel: "Donaciones",
        routeNames: ["donaciones-list"],
    },
    tasks: {
        availableFor: ["course"],
        drawerLabel: "Tareas",
        routeNames: ["tareas-mis", "tareas-grupo", "tareas-nueva", "tareas-detalle"],
        routePrefixes: ["/user/tareas"],
    },
    "mass-email": {
        availableFor: ["course"],
        drawerLabel: "Email masivo",
        routeNames: ["email-masivo"],
    },
    "cpa-mass-email": {
        availableFor: ["cpa"],
        drawerLabel: "Comunicaciones masivas",
        routeNames: ["email-masivo-cpa"],
    },
    "sent-notifications": {
        availableFor: ["course", "cpa"],
        drawerLabel: "Notificaciones enviadas",
        routeNames: [
            "notificaciones-email-list",
            "notificaciones-email-detalle",
        ],
        routePrefixes: ["/user/notificaciones-email"],
    },
    website: {
        availableFor: ["cpa"],
        drawerLabel: "Sitio web",
        routeNames: ["sitio-web-dashboard"],
        routePrefixes: ["/user/cpa/sitio-web"],
        routeNamePrefixes: ["sitio-web-"],
    },
    "graphic-material": {
        availableFor: ["cpa"],
        drawerLabel: "Material gráfico",
        routeNames: ["material-grafico-credenciales"],
        routePrefixes: ["/user/cpa/material-grafico"],
        routeNamePrefixes: ["material-grafico-"],
    },
    galleries: {
        availableFor: ["cpa"],
        drawerLabel: "Galerías",
        routeNames: [
            "galerias-admin",
            "galerias-detalle",
            "galerias-list",
            "galerias-public-detalle",
        ],
        routePrefixes: ["/user/cpa/galerias", "/user/galerias"],
        routeNamePrefixes: ["galerias-"],
    },
    "association-link": {
        availableFor: ["course"],
        drawerLabel: "Crear link asociación",
        routeNames: ["crear-link-asociacion-curso"],
    },
    "edit-board": {
        availableFor: ["course"],
        drawerLabel: "Modificar directiva",
        routeNames: ["modificar-directiva"],
    },
    "cpa-board": {
        availableFor: ["cpa"],
        drawerLabel: "Directiva CPA",
        routeNames: ["modificar-directiva"],
    },
};
const extraModule = (def) => ({
    ...DEFAULT_MODULE_FLAGS,
    surfaces: def.surfaces ?? ["drawer"],
    routeNames: def.routeNames ?? [def.routeName],
    ...def,
});
/** Módulos que hoy viven fuera del hub: tesorería, staff, kiosco operativo, Home. */
const EXTRA_MODULES = [
    extraModule({
        id: "home-summary",
        labelKey: "activities.features.homeSummary.label",
        icon: "bi bi-house-door",
        routeName: "main-view",
        section: "account",
        availableFor: ["course", "cpa", "funcionarios", "kiosk"],
        drawerLabel: "Resumen",
        routeNames: ["main-view"],
        canAccess: () => true,
        userCanPin: false,
        configurableByGroup: false,
    }),
    extraModule({
        id: "cpa-home",
        labelKey: "activities.features.cpaHome.label",
        icon: "bi bi-speedometer2",
        routeName: "menu-cpa",
        section: "account",
        availableFor: ["cpa"],
        drawerLabel: "Inicio CPA",
        routeNames: ["menu-cpa"],
        canAccess: (ctx) => isCpaBoard(ctx),
        userCanPin: false,
        configurableByGroup: false,
    }),
    extraModule({
        id: "treasury-payments",
        labelKey: "activities.features.treasuryPayments.label",
        icon: "bi bi-cash-stack",
        routeName: "ver-pagos-generales",
        section: "treasury",
        availableFor: ["course", "cpa"],
        drawerLabel: "Pagos y recaudación",
        routeNames: ["ver-pagos-generales", "ver-pagos-usuario"],
        configurableByGroup: false,
        canAccess: (ctx) => Boolean(ctx.curso) &&
            !isFuncionariosCourse(ctx.curso) &&
            !isKioskCourse(ctx.curso),
    }),
    extraModule({
        id: "treasury-funds",
        labelKey: "activities.features.treasuryFunds.label",
        icon: "bi bi-piggy-bank",
        routeName: "gestion-centro-costos",
        section: "treasury",
        availableFor: ["course", "cpa"],
        drawerLabel: "Fondos de recaudación",
        routeNames: ["gestion-centro-costos", "detalle-fondo"],
        requiresTipoTesoreria: "centro_costos",
        configurableByGroup: false,
        canAccess: (ctx) => Boolean(ctx.curso) &&
            !isFuncionariosCourse(ctx.curso) &&
            !isKioskCourse(ctx.curso),
    }),
    extraModule({
        id: "treasury-validate-payments",
        labelKey: "activities.features.treasuryValidatePayments.label",
        icon: "bi bi-check2-circle",
        routeName: "validar-pagos",
        section: "treasury",
        availableFor: ["course", "cpa"],
        drawerLabel: "Validar pagos a fondo",
        routeNames: ["validar-pagos"],
        requiresRoles: ["treasurer"],
        configurableByGroup: false,
        canAccess: (ctx) => canActAsTreasurer(ctx.curso, ctx.userEmail),
    }),
    extraModule({
        id: "treasury-incomes",
        labelKey: "activities.features.treasuryIncomes.label",
        icon: "bi bi-graph-up-arrow",
        routeName: "ver-ingresos",
        section: "treasury",
        availableFor: ["course", "cpa"],
        drawerLabel: "Ingresos",
        routeNames: ["ver-ingresos", "registrar-ingreso"],
        configurableByGroup: false,
        canAccess: (ctx) => Boolean(ctx.curso) &&
            !isFuncionariosCourse(ctx.curso) &&
            !isKioskCourse(ctx.curso),
    }),
    extraModule({
        id: "treasury-expenses",
        labelKey: "activities.features.treasuryExpenses.label",
        icon: "bi bi-graph-down-arrow",
        routeName: "ver-gastos",
        section: "treasury",
        availableFor: ["course", "cpa"],
        drawerLabel: "Gastos",
        routeNames: ["ver-gastos", "registrar-gasto"],
        configurableByGroup: false,
        canAccess: (ctx) => Boolean(ctx.curso) &&
            !isFuncionariosCourse(ctx.curso) &&
            !isKioskCourse(ctx.curso),
    }),
    extraModule({
        id: "treasury-register-expense",
        labelKey: "activities.features.treasuryRegisterExpense.label",
        icon: "bi bi-file-minus",
        routeName: "registrar-gasto",
        section: "treasury",
        availableFor: ["course", "cpa"],
        drawerLabel: "Registrar gasto",
        routeNames: ["registrar-gasto"],
        configurableByGroup: false,
        canAccess: (ctx) => canActAsTreasurer(ctx.curso, ctx.userEmail),
    }),
    extraModule({
        id: "treasury-register-income",
        labelKey: "activities.features.treasuryRegisterIncome.label",
        icon: "bi bi-file-plus",
        routeName: "registrar-ingreso",
        section: "treasury",
        availableFor: ["course", "cpa"],
        drawerLabel: "Registrar ingreso extra",
        routeNames: ["registrar-ingreso"],
        configurableByGroup: false,
        canAccess: (ctx) => canActAsTreasurer(ctx.curso, ctx.userEmail),
    }),
    extraModule({
        id: "treasury-register-payment",
        labelKey: "activities.features.treasuryRegisterPayment.label",
        icon: "bi bi-credit-card",
        routeName: "registrar-abono-centro-costo",
        section: "treasury",
        availableFor: ["course"],
        drawerLabel: "Registrar pagos",
        routeNames: ["registrar-abono-centro-costo"],
        surfaces: ["drawer", "home-shortcut"],
        configurableByGroup: false,
        canAccess: ({ curso }) => isNormalCourse(curso),
    }),
    extraModule({
        id: "treasury-my-payments",
        labelKey: "activities.features.treasuryMyPayments.label",
        icon: "bi bi-clock-history",
        routeName: "registrar-abonos-por-cc",
        section: "treasury",
        availableFor: ["course"],
        drawerLabel: "Ver mis pagos",
        routeNames: ["registrar-abonos-por-cc"],
        configurableByGroup: false,
        canAccess: ({ curso }) => isNormalCourse(curso),
    }),
    extraModule({
        id: "treasury-my-debts",
        labelKey: "activities.features.treasuryMyDebts.label",
        icon: "bi bi-wallet2",
        routeName: "mis-deudas",
        section: "treasury",
        availableFor: ["course"],
        drawerLabel: "Mis deudas",
        routeNames: ["mis-deudas"],
        requiresTipoTesoreria: "centro_costos",
        configurableByGroup: false,
        canAccess: ({ curso }) => isNormalCourse(curso),
    }),
    extraModule({
        id: "treasury",
        labelKey: "activities.features.treasury.label",
        icon: "bi bi-wallet2",
        routeName: "main-view",
        section: "treasury",
        availableFor: ["course", "cpa"],
        drawerLabel: "Tesorería",
        surfaces: [],
        userCanPin: false,
        canAccess: (ctx) => Boolean(ctx.curso) &&
            !isFuncionariosCourse(ctx.curso) &&
            !isKioskCourse(ctx.curso),
    }),
    extraModule({
        id: "bank-statements",
        labelKey: "activities.features.bankStatements.label",
        icon: "bi bi-bank",
        routeName: "main-view",
        section: "treasury",
        availableFor: ["course", "cpa"],
        drawerLabel: "Cartolas bancarias",
        surfaces: [],
        userCanPin: false,
        canAccess: (ctx) => Boolean(ctx.curso) &&
            !isFuncionariosCourse(ctx.curso) &&
            !isKioskCourse(ctx.curso),
    }),
    extraModule({
        id: "users-group",
        labelKey: "activities.features.usersGroup.label",
        icon: "bi bi-people",
        routeName: "ver-usuarios-grupo",
        section: "organization",
        availableFor: ["course", "kiosk"],
        drawerLabel: "Chat de grupo",
        routeNames: ["ver-usuarios-grupo"],
        canAccess: ({ curso }) => Boolean(curso) && !isFuncionariosCourse(curso) && !isCpaCourse(curso),
    }),
    extraModule({
        id: "users-manage",
        labelKey: "activities.features.usersManage.label",
        icon: "bi bi-people-gear",
        routeName: "ver-usuarios",
        section: "organization",
        availableFor: ["course"],
        drawerLabel: "Ver usuarios",
        routeNames: ["ver-usuarios"],
        surfaces: ["drawer", "home-shortcut"],
        canAccess: (ctx) => isNormalCourse(ctx.curso) &&
            canActAsDirectivaGestion(ctx.curso, ctx.userEmail),
    }),
    extraModule({
        id: "guardian-withdrawals",
        labelKey: "activities.features.guardianWithdrawals.label",
        icon: "bi bi-door-open",
        routeName: "mis-retiros",
        section: "activities",
        availableFor: ["course"],
        drawerLabel: "Retiros de alumnos",
        routeNames: ["mis-retiros"],
        surfaces: ["drawer", "home-shortcut"],
        canAccess: ({ curso }) => canAccessGuardianWithdrawals(curso),
    }),
    extraModule({
        id: "staff-validate-withdrawal",
        labelKey: "activities.features.staffValidateWithdrawal.label",
        icon: "bi bi-shield-check",
        routeName: "validar-retiro",
        section: "staff",
        availableFor: ["funcionarios"],
        drawerLabel: "Validar llegada",
        routeNames: ["validar-retiro"],
        canAccess: ({ curso }) => canValidateWithdrawalArrival(curso),
    }),
    extraModule({
        id: "staff-scan-barcode",
        labelKey: "activities.features.staffScanBarcode.label",
        icon: "bi bi-upc-scan",
        routeName: "escanear-barcode-poc",
        section: "staff",
        availableFor: ["funcionarios"],
        drawerLabel: "Escanear código de barras (POC)",
        routeNames: ["escanear-barcode-poc"],
        canAccess: ({ curso }) => canValidateWithdrawalArrival(curso),
    }),
    extraModule({
        id: "staff-day-withdrawals",
        labelKey: "activities.features.staffDayWithdrawals.label",
        icon: "bi bi-calendar-day",
        routeName: "retiros-dia-guardia",
        section: "staff",
        availableFor: ["funcionarios"],
        drawerLabel: "Retiros del día",
        routeNames: ["retiros-dia-guardia"],
        canAccess: ({ curso }) => Boolean(curso) &&
            isFuncionariosCourse(curso) &&
            !isDriverCourse(curso) &&
            (isGateGuardCourse(curso) ||
                (canViewWithdrawalDayList(curso) &&
                    !canManageWithdrawalBoard(curso))),
    }),
    extraModule({
        id: "staff-withdrawal-board",
        labelKey: "activities.features.staffWithdrawalBoard.label",
        icon: "bi bi-kanban",
        routeName: "tablero-retiros",
        section: "staff",
        availableFor: ["funcionarios"],
        drawerLabel: "Tablero de retiros",
        routeNames: ["tablero-retiros"],
        canAccess: ({ curso }) => canManageWithdrawalBoard(curso),
    }),
    extraModule({
        id: "staff-validate-entry",
        labelKey: "activities.features.staffValidateEntry.label",
        icon: "bi bi-qr-code-scan",
        routeName: "validar-ingreso",
        section: "staff",
        availableFor: ["funcionarios"],
        drawerLabel: "Validar QR",
        routeNames: ["validar-ingreso"],
        canAccess: ({ curso }) => isInspectorCourse(curso),
    }),
    extraModule({
        id: "staff-inspect-guardians",
        labelKey: "activities.features.staffInspectGuardians.label",
        icon: "bi bi-people",
        routeName: "inspector-apoderados",
        section: "staff",
        availableFor: ["funcionarios"],
        drawerLabel: "Apoderados del colegio",
        routeNames: ["inspector-apoderados"],
        canAccess: ({ curso }) => isInspectorCourse(curso),
    }),
    extraModule({
        id: "staff-qr-logs",
        labelKey: "activities.features.staffQrLogs.label",
        icon: "bi bi-journal-text",
        routeName: "inspector-qr-logs",
        section: "staff",
        availableFor: ["funcionarios"],
        drawerLabel: "Logs de QR",
        routeNames: ["inspector-qr-logs"],
        canAccess: ({ curso }) => isInspectorCourse(curso),
    }),
    extraModule({
        id: "driver-panel",
        labelKey: "activities.features.driverPanel.label",
        icon: "bi bi-bus-front",
        routeName: "transporte",
        section: "staff",
        availableFor: ["funcionarios"],
        drawerLabel: "Panel",
        routeNames: ["transporte"],
        canAccess: ({ curso }) => isDriverCourse(curso),
    }),
    extraModule({
        id: "driver-trip",
        labelKey: "activities.features.driverTrip.label",
        icon: "bi bi-play-circle",
        routeName: "transporte-viaje",
        section: "staff",
        availableFor: ["funcionarios"],
        drawerLabel: "Viaje",
        routeNames: ["transporte-viaje"],
        canAccess: ({ curso }) => isDriverCourse(curso),
    }),
    extraModule({
        id: "driver-routes",
        labelKey: "activities.features.driverRoutes.label",
        icon: "bi bi-signpost-2",
        routeName: "transporte-rutas",
        section: "staff",
        availableFor: ["funcionarios"],
        drawerLabel: "Mis rutas",
        routeNames: ["transporte-rutas"],
        canAccess: ({ curso }) => isDriverCourse(curso),
    }),
    extraModule({
        id: "driver-requests",
        labelKey: "activities.features.driverRequests.label",
        icon: "bi bi-inbox",
        routeName: "transporte-solicitudes",
        section: "staff",
        availableFor: ["funcionarios"],
        drawerLabel: "Solicitudes",
        routeNames: ["transporte-solicitudes"],
        canAccess: ({ curso }) => isDriverCourse(curso),
    }),
];
const enrichHubModule = (feature) => {
    const meta = MODULE_META[feature.id];
    if (!meta) {
        throw new Error(`Module meta missing for hub feature: ${feature.id}`);
    }
    return {
        ...feature,
        ...DEFAULT_MODULE_FLAGS,
        ...meta,
        routeNames: meta.routeNames ?? [feature.routeName],
    };
};
export const MODULE_REGISTRY = [
    ...ACTIVITY_FEATURES.map(enrichHubModule),
    ...EXTRA_MODULES,
];
const MODULES_BY_ID = new Map(MODULE_REGISTRY.map((mod) => [mod.id, mod]));
export const getModuleById = (id) => MODULES_BY_ID.get(id);
export const requireModule = (id) => {
    const mod = getModuleById(id);
    if (!mod) {
        throw new Error(`Unknown module: ${id}`);
    }
    return mod;
};
export const toDrawerOption = (id, overrides) => {
    const mod = requireModule(id);
    return {
        texto: mod.drawerLabel ?? mod.id,
        icono: mod.drawerIcon ?? mod.icon,
        ruta: mod.routeName,
        routeNames: mod.routeNames,
        routePrefixes: mod.routePrefixes,
        routeNamePrefixes: mod.routeNamePrefixes,
        requiresTipoTesoreria: mod.requiresTipoTesoreria,
        requiresRoles: mod.requiresRoles,
        ...overrides,
        moduleId: id,
    };
};
export const isModuleOptionActive = (option, routeName, routePath) => {
    if (option.ruta && option.ruta === routeName)
        return true;
    if (option.routeNames?.includes(routeName))
        return true;
    if (option.routePrefixes?.some((p) => routePath.startsWith(p)))
        return true;
    if (option.routeNamePrefixes?.some((p) => routeName.startsWith(p))) {
        return true;
    }
    return false;
};
export const listAccessibleActivities = (ctx, surface = "hub") => MODULE_REGISTRY.filter((f) => f.surfaces.includes(surface) && f.canAccess(ctx));
/** Atajos de Home actuales → id del registry (el grid no cambia). */
export const HOME_SHORTCUT_MODULE_ID = {
    "gestionar-cursos": "courses-boards",
    "email-masivo": "mass-email",
    fondos: "treasury-funds",
    "ver-usuarios": "users-manage",
    abonar: "treasury-register-payment",
    "pago": "treasury-register-payment",
    "mis-pagos": "treasury-my-payments",
    "ver-grupo": "users-group",
    "mis-deudas": "treasury-my-debts",
    retiros: "guardian-withdrawals",
};
